require('./bootstrap');

import Vue from 'vue';
import AOS from 'aos';
import 'aos/dist/aos.css';

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload)

import {
  Button,
  Badge,
  Popover,
  Tooltip,
  Message,
  Loading,
  MessageBox,
  Rate,
  Alert
} from 'element-ui';
import '../sass/element-ui-variables.scss';

Vue.use(Loading.directive);
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.component('show-message', require('./components/ShowMessage.vue').default);

const app = new Vue({
    el: '#vue-app',
    created() {
      AOS.init()
    },
    methods: {
      showStaffDetail(id, title, buttonText) {
        axios.get('/get-staff-content', {
          params: {
            id: id
          }
        })
        .then((response) => {
          this.$alert(response.data.content, title, {
            dangerouslyUseHTMLString: true,
            showConfirmButton: true,
            confirmButtonText: buttonText,
            callback: action => {
              //
            }
          });
        })
        .catch((error) => {
          // setTimeout(() => {
          // }, 500);
        });
      },

      showAdviserDetail(id, title, buttonText) {
        axios.get('/get-adviser-content', {
          params: {
            id: id
          }
        })
        .then((response) => {
          this.$alert(response.data.content, title, {
            dangerouslyUseHTMLString: true,
            showConfirmButton: true,
            confirmButtonText: buttonText,
            callback: action => {
              //
            }
          });
        })
        .catch((error) => {
          // setTimeout(() => {
          // }, 500);
        });
      }
    }
});

window.UiEvent = new Vue();

UiEvent.success = (message, showClose = true) => {
    Vue.prototype.$message({
      showClose: showClose,
      duration: 3000,
      dangerouslyUseHTMLString: true,
      message: message,
      type: 'success'
    });
}
UiEvent.warning = (message, showClose = true) => {
    Vue.prototype.$message({
      showClose: showClose,
      duration: 3000,
      dangerouslyUseHTMLString: true,
      message: message,
      type: 'warning'
    });
}
UiEvent.error = (message, showClose = true) => {
    Vue.prototype.$message({
      showClose: showClose,
      duration: 3000,
      dangerouslyUseHTMLString: true,
      message: message,
      type: 'error'
    });
}
